import { AfterContentInit, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { UserProfileService } from '../../user-profile.service';
import Vs from '@app/services/validators/validators.service'
import {DatePipe} from "@angular/common";
import { TranslateService } from '@ngx-translate/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { isEmpty } from 'ramda';
import { ServiceConfigService } from '@app/services/service-config.service';
import { GlobalTranslateService } from '@app/services/globalTranslate/globalTranslate.service';
import { from } from 'rxjs';
declare let gtag: Function;    // Google Analytics function

@Component({
    selector: 'my-letters',
    templateUrl: './my-letters.component.html',
    styleUrls: ['./my-letters.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class MyLettersComponent implements OnInit, AfterContentInit {
     today: any = new Date();
     minimumDate = new Date("1900-01-01T00:00:00.000-06:00");
        search = new FormGroup({
            type: new FormControl('AL'),
            beginDate: new FormControl('', [Vs.required]),
            endDate: new FormControl('', [Vs.required])
        })
        beginDateError: any = { isError: false, errorMessage: '' };
        endDateError: any = { isError: false, errorMessage: '' };

    itemsEn = [{ code: 'AL', value: 'All' }, { code: 'ED', value: 'Eligibility' }, { code: 'AP', value: 'Appeal' }];
    itemsSp = [{ code: 'AL', value: 'Todos' }, { code: 'ED', value: 'Elegibilidad' }, { code: 'AP', value: 'Apelación' }];
    items;

    columns = [
        /*{ name: 'Letter Name', prop: 'letterName' },*/
        { name: 'Letter For', prop: 'letterFor' },
        { name: 'Date', prop: 'date' },
        { name: 'Letter Viewed?', prop: 'viewed' },
    ];
    isRmbRmc = false;
    rows;
    limit = 5;
    start = 1;
    end;
    linkMyCase = false;
    emptyMessage;
    emptyMessageEn = "No results for your search";
    emptyMessageSp = "No hay resultados para su búsqueda";
    translatedLang;
    indivId = sessionStorage.getItem('individualId');
    isAppealLetter: boolean = false;
    userType = sessionStorage.getItem('userType');
    isFromPartnerPortal = this.userType === 'RP' && !isEmpty(this.indivId);
    budgetInfoSwitch: boolean = false;
    privacyNoticeViewSw: boolean = false;
    privacyTooltipLabel: string = '';
    privacyTooltipContent: string = '';
    constructor(private userProfileService: UserProfileService, private datePipe: DatePipe,  public translateService: TranslateService,private titleService: Title, private router: Router, private readonly serviceConfigService: ServiceConfigService, private globalTranslateService: GlobalTranslateService) { 
    this.titleService.setTitle('My letters');
    }

    get f() {
        return this.search.controls;
    }

    ngOnInit(): void {
        this.budgetInfoSwitch = this.serviceConfigService.getServerConfig().budgetInfoSwitch;
        this.privacyNoticeViewSw = this.serviceConfigService.getServerConfig().privacyNoticeViewSw;
        // Clear budget-related data
        sessionStorage.removeItem('nodBudgetPayload');
        sessionStorage.removeItem('budgetDetailsState');
        sessionStorage.removeItem('budgetSubScreenData');
    }

    ngAfterContentInit() {
        const defaultLanguage = this.translateService.getDefaultLang();
        this.translatedLang = defaultLanguage;
        if (defaultLanguage !== 'en') { 
            this.emptyMessage = this.emptyMessageSp;
            this.items = this.itemsSp;
        } else {
            this.emptyMessage = this.emptyMessageEn;
            this.items = this.itemsEn;
        }
        this.translateService.onDefaultLangChange.subscribe((res) => {
            this.translatedLang = res.lang;
            if (res.lang !== 'en') {
                this.emptyMessage = this.emptyMessageSp;
                this.items = this.itemsSp;
            } else {
                this.emptyMessage = this.emptyMessageEn;
                this.items = this.itemsEn;
            }
            this.loadPrivacyTranslations();
        });
        this.loadPrivacyTranslations();
        const indivId = sessionStorage.getItem('individualId');
        if (!indivId || indivId === '0' || indivId == 'undefined' || indivId == 'null') {
        this.linkMyCase = true;
        }
        const appealLetter = sessionStorage.getItem('appealLetter');
        if (appealLetter === 'true') {
          this.search.controls.type.patchValue("AP");
          sessionStorage.removeItem('appealLetter');
        }
        this.searchData()
    }


    searchData() {
        this.userProfileService.getLetters(this.indivId, this.f.type.value, this.f.beginDate.value, this.f.endDate.value).subscribe((res: any) => {
            if (res && res.length > 0) {
                const data = [...res];
                this.rows = data.map(letter => {
                    const pickDate = letter.sentDt?.slice(0, 10);
                    const uploadDate = this.datePipe.transform(pickDate, "MMMM d, y");
                    return {
                        letterName: letter.letterDescription,
                        letterFor: letter.appealNum ? `Appeal ${letter.appealNum}` : letter.caseNum ? `Case ${letter.caseNum}` :'',
                        date: uploadDate,
                        viewed: letter.letterViewedSW === 'Y' ? 'Yes' : 'No',
                        fID: letter.fileNetDocId,
                        indivID: letter.indvId,
                        reqSeq: letter.coReqSeq,
                        hoHFirstName: letter.hoHFirstName,
                        hoHLastName: letter.hoHLastName,
                        indvId: letter.indvId,
                        fileNetDocId: letter.fileNetDocId,
                        coReqSeq: letter.coReqSeq,
                        caseNum: letter.caseNum,
                        appealNum: letter.appealNum,
                        printDate: letter.printDate,
                        letterViewedSW: letter.letterViewedSW,
                        letterFavoritedSW: letter.letterFavoritedSW,
                        letterDescription: letter.letterDescription,
                        letterDescriptionES: letter.letterDescriptionES,
                        methodSentDescription: letter.methodSentDescription,
                        methodSentDescriptionES: letter.methodSentDescriptionES,
                        privacySuppressSW: letter.privacySuppressSW ?? null
                    }
                })
                if (this.rows?.length && this.rows?.length > 1) {
                    this.rows.sort((a, b) => {
                        return new Date(b?.date).getTime() - new Date(a?.date).getTime();
                    });
                }
                this.end = this.rows.length < 5 ? this.rows.length : this.limit;
            } else {
                this.start = 0; 
                this.end = 0;
                this.rows = [];
            }
        })

        if (this.search.controls.type.value === 'AL' || this.search.controls.type.value === 'AP') {
            this.isAppealLetter = true;
        } else {
            this.isAppealLetter = false;
        }
    }

     verifyTwoDates(event, from) {
        const date = event?.target?.value ? event?.target?.value : event ? event : null;
        
        // Add a small delay to ensure form control values are updated (especially for datepicker)
        setTimeout(() => {
            // Get current values after potential form update
            const beginDateValue = this.search.controls['beginDate'].value;
            const endDateValue = this.search.controls['endDate'].value;
            
            // Handle empty/cleared dates
            if ((!date || date === '') && from === 'beginDate' && !beginDateValue) {
                this.beginDateError = { isError: false, errorMessage: '' };
                this.endDateError = { isError: false, errorMessage: '' };
                return;
            }
            if ((!date || date === '') && from === 'endDate' && !endDateValue) {
                this.beginDateError = { isError: false, errorMessage: '' };
                this.endDateError = { isError: false, errorMessage: '' };
                return;
            }
            
            // Check if dates are valid before comparison
            const isBeginDateValid = this.isValidDate(beginDateValue);
            const isEndDateValid = this.isValidDate(endDateValue);
            
            // Only proceed with validation if both dates exist and are valid
            if (isBeginDateValid && isEndDateValid) {
                // Compare actual Date objects, not formatted strings
                const beginDate = new Date(beginDateValue);
                const endDate = new Date(endDateValue);
                
                // Check if begin date is after end date
                if(beginDate && endDate && beginDate > endDate) {
                    // Determine which field should show the error based on which was changed
                    if(from === 'beginDate') {
                        this.beginDateError = { isError: true, errorMessage: 'BEGIN_DATE_BEFORE_END_DATE' };
                        this.endDateError = { isError: false, errorMessage: '' };
                    } else {
                        this.endDateError = { isError: true, errorMessage: 'BEGIN_DATE_BEFORE_END_DATE' };
                        this.beginDateError = { isError: false, errorMessage: '' };
                    }
                } 
                // Check if dates are more than 12 months apart
                else if (this.monthDiff(beginDate, endDate) > 365) {
                    // Show error on the field that was changed
                    if(from === 'beginDate') {
                        this.beginDateError = { isError: true, errorMessage: 'INVALID_DATE_RANGE' };
                        this.endDateError = { isError: false, errorMessage: '' };
                    } else {
                        this.endDateError = { isError: true, errorMessage: 'INVALID_DATE_RANGE' };
                        this.beginDateError = { isError: false, errorMessage: '' };
                    }
                }
                else {
                    // Clear errors if dates are valid
                    this.beginDateError = { isError: false, errorMessage: '' };
                    this.endDateError = { isError: false, errorMessage: '' };
                }
            } else {
                // Clear errors if one or both dates are invalid/empty
                this.beginDateError = { isError: false, errorMessage: '' };
                this.endDateError = { isError: false, errorMessage: '' };
            }
        }, 0);
    };


    monthDiff(d1, d2) {
        const Difference_In_Time = d2.getTime() - d1.getTime();
        const Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
        return Difference_In_Days <= 0 ? 0 : Difference_In_Days;
    }

    onPage(e) {
        this.start = e.offset * this.limit + 1;
        this.end = this.rows.length < 5 ? this.rows.length : this.start - 1 + this.limit;
    }

    printPdf(row) {
        const payload = {
            hoHFirstName: row.hoHFirstName,
            hoHLastName: row.hoHLastName,
            indvId: row.indvId,
            fileNetDocId: row.fileNetDocId,
            coReqSeq: row.coReqSeq,
            caseNum: row.caseNum,
            appealNum: row.appealNum,
            printDate: row.printDate,
            letterViewedSW: "Y",
            letterFavoritedSW: row.letterFavoritedSW,
            letterDescription: row.letterDescription,
            letterDescriptionES: row.letterDescriptionES,
            methodSentDescription: row.methodSentDescription,
            methodSentDescriptionES: row.methodSentDescriptionES
        }
        this.userProfileService.getPrintDocPdf(payload).subscribe((res: any) => {
            const file = new Blob([res], { type: 'application/pdf' });
            const fileURL = URL.createObjectURL(file);
            window.open(fileURL);
            this.searchData()
        })
    }
    getRowClass(row) {
        const classes = [];
        if (row.viewed === 'No') classes.push('row-highlight');
        if (row.privacySuppressSW === 'Y') classes.push('privacy-suppressed');
        return classes.join(' ');
    }

    goToMyAppeals() {
        this.router.navigate(['/user-profile', 'my-appeals']);
    }

    viewBudget(row) {
        if (row) {
            const nodBudgetPayload = { coReqSeq: row?.coReqSeq, caseNum: row?.caseNum };
            sessionStorage.setItem('nodBudgetPayload', JSON.stringify(nodBudgetPayload));
            this.router.navigate(['/user-profile/budget-details']);
        }
    }

    /**
     * Helper method to check if a value is a valid date
     * @param value - The value to check
     * @returns true if the value is a valid date, false otherwise
     */
    private isValidDate(value: any): boolean {
        if (!value) return false;
        
        // Check if it's already a Date object
        if (value instanceof Date) {
            return !isNaN(value.getTime());
        }
        
        // Check if it's a string that represents a valid date
        if (typeof value === 'string') {
            // Reject obviously invalid date strings
            if (value.toLowerCase().includes('invalid')) {
                return false;
            }
            
            const date = new Date(value);
            return !isNaN(date.getTime());
        }
        
        return false;
    }

    // Logic to track clicks on links within the privacy popover content
    onPrivacyToolTipContentClick(event: MouseEvent) {
        if ((event.target as HTMLElement).tagName === 'A') {
            gtag('event', 'privacy_notice_email_click', {
                'event_category': 'privacy_notice',
                'event_label': 'privacy_notice_email_click'
            });
        }
    }
    
    // Logic to show/hide the privacy popover when hovering over the "Unavailable" tooltip icon
    private privacyPopoverHideTimer: any;
    private privacyClickOpened = false;
    currentPrivacyPop: any;

    showPrivacyPopover(pop: any) {
        clearTimeout(this.privacyPopoverHideTimer);
        this.currentPrivacyPop = pop;
        pop.show();
    }

    hidePrivacyPopover(pop: any) {
        if (this.privacyClickOpened) return;
        this.privacyPopoverHideTimer = setTimeout(() => pop?.hide(), 200);
    }

    togglePrivacyPopover(event: Event, pop: any) {
        event.stopPropagation();
        if (pop.isOpen && this.privacyClickOpened) {
            // Already click-opened — click again to close
            this.privacyClickOpened = false;
            pop.hide();
        } else {
            // Closed, or hover-opened — click to lock it open
            this.privacyClickOpened = true;
            clearTimeout(this.privacyPopoverHideTimer);
            this.currentPrivacyPop = pop;
            pop.show();
        }
    }

    onPrivacyPopoverHidden() {
        this.privacyClickOpened = false;
    }
    

    private loadPrivacyTranslations() {
        const awsTranslateSwitch = this.serviceConfigService.getServerConfig().awsTranslateSwitch;
        let selectedLang = sessionStorage.getItem('globalTranslatedLan') && sessionStorage.getItem('globalTranslatedLan') !== 'undefined'
            ? sessionStorage.getItem('globalTranslatedLan') : null;

        if (awsTranslateSwitch && selectedLang === 'es') {
            selectedLang = 'sp';
        }

        const useAwsTranslate = awsTranslateSwitch && selectedLang && selectedLang !== 'en' && selectedLang !== 'sp';

        this.translateService.get(['MY_LETTERS_PRIVACY_TOOLTIP', 'MY_LETTERS_PRIVACY_TOOLTIP_CONTENT']).subscribe(translations => {
            const labelEn = translations['MY_LETTERS_PRIVACY_TOOLTIP'] ?? '';
            const contentEn = translations['MY_LETTERS_PRIVACY_TOOLTIP_CONTENT'] ?? '';

            if (!useAwsTranslate) {
                this.privacyTooltipLabel = labelEn;
                this.privacyTooltipContent = contentEn;
            } else {
                const labelInput = labelEn !== 'MY_LETTERS_PRIVACY_TOOLTIP' ? labelEn : 'MY_LETTERS_PRIVACY_TOOLTIP';
                const contentInput = contentEn !== 'MY_LETTERS_PRIVACY_TOOLTIP_CONTENT' ? contentEn : 'MY_LETTERS_PRIVACY_TOOLTIP_CONTENT';

                from(this.globalTranslateService.translate(labelInput, selectedLang)).subscribe(translated => {
                    this.privacyTooltipLabel = translated;
                });
                from(this.globalTranslateService.translate(contentInput, selectedLang)).subscribe(translated => {
                    this.privacyTooltipContent = translated;
                });
            }
        });
    }
}